import { FormGroup } from '@angular/forms';

export enum FormTypes {
  // Transversal content
  SLIDES = 'slide',
  BLOCK = 'block',

  // Database section
  ADDRESS = 'address',
  ARTIST = 'artist',
  COLLECTOR = 'collector',
  OTHER = 'other',
  SELLER = 'seller',
  WORK = 'work',

  // Other form
  PREFERENCES = 'preferences',
}

export interface FormMetadata {
  name: string;
}
// Used to build message about the form
export const FORM_TYPES_CONTENT_NAME: Record<FormTypes, FormMetadata> = {
  // Transerversal content
  [FormTypes.SLIDES]: {
    name: 'slide',
  },
  [FormTypes.BLOCK]: {
    name: 'block',
  },

  // Databases
  [FormTypes.ADDRESS]: {
    name: 'address',
  },
  [FormTypes.ARTIST]: {
    name: 'artist',
  },
  [FormTypes.COLLECTOR]: {
    name: 'address',
  },
  [FormTypes.OTHER]: {
    name: 'other',
  },
  [FormTypes.SELLER]: {
    name: 'seller',
  },
  [FormTypes.WORK]: {
    name: 'work',
  },
  // Other forms
  [FormTypes.PREFERENCES]: {
    name: 'preferences',
  },
};

// In order to handle the forms of the app in the same way
// Especially using guards, it is necesarry to standardize the naming
// and behavior of the following property / methods
// This interface is at least use by canLeave Page guard
export interface ArsultimaForm {
  formType: FormTypes;

  // this public property store the form
  form: FormGroup;

  // This method save the form
  save: () => any;

  // Any other props / methods is allowed
  [key: string]: any;
}
